import {
    JSONCensusSuggestedActionsAnalysisSummary,
    MappedDetailCount,
    MappedSummary,
} from "../../data/models/JSONCensusSuggestedActionsAnalysisSummary";

import {AppTranslations} from "../../../../../components/Utils/translations/AppTranslations";
import {
    ActionsEnum,
    CensusEnums,
    CensusEquipmentStatusDetailsEnum,
    CensusEquipmentStatusesEnum,
    CensusEquipmentStatusReasons,
} from "../../data/models/CensusEnums";
import {Section} from "./types";

declare var AppTranslations: AppTranslations;

export const mapSummaryGroupedByStatusAndStatusDetail = (
    summary: JSONCensusSuggestedActionsAnalysisSummary,
): MappedSummary[] => {
    const mappedSummary: MappedSummary[] = [];
    summary?.summary?.forEach((summaryItem) => {
        const {statusAndDetailCount, suggestedAction, availableActions} = summaryItem;
        const {
            inventoryStatus,
            inventoryStatusDetail,
            inventoryStatusReason,
            count,
        } = statusAndDetailCount;

        const existingMappedSummary = mappedSummary.find((mappedItem) => {
            return (
                mappedItem.inventoryStatus === inventoryStatus &&
                mappedItem.inventoryStatusDetail === inventoryStatusDetail
            );
        });

        if (existingMappedSummary) {
            const prevReason: MappedDetailCount = {
                count: existingMappedSummary.count,
                inventoryStatusReason: existingMappedSummary.inventoryStatusReason ?? CensusEquipmentStatusReasons.OTHER,
                suggestedAction: existingMappedSummary.suggestedAction,
                availableActions: existingMappedSummary.availableActions,
            };
            existingMappedSummary.withReason.push(prevReason);

            existingMappedSummary.count += count;
            existingMappedSummary.suggestedAction = undefined;
            existingMappedSummary.inventoryStatusReason = undefined;
            existingMappedSummary.availableActions = [];
            existingMappedSummary.withReason.push({
                count,
                inventoryStatusReason: inventoryStatusReason ?? CensusEquipmentStatusReasons.OTHER,
                suggestedAction: suggestedAction ?? ActionsEnum.NO_ACTION,
                availableActions: availableActions
            });
        } else {
            mappedSummary.push({
                count,
                inventoryStatus,
                inventoryStatusDetail,
                inventoryStatusReason,
                suggestedAction: suggestedAction ?? ActionsEnum.NO_ACTION,
                withReason: [],
                availableActions
            });
        }
    });
    return mappedSummary;
};

export const getHeaderDetailsHeader = (
    detail: MappedDetailCount,
    data: CensusEnums,
) => {
    if (detail.inventoryStatusReason === CensusEquipmentStatusReasons.OTHER) {
        return `${AppTranslations.genericWords.other}`;
    }
    return (`${
        detail?.inventoryStatusReason && data
            ? `${data?.censusEquipmentStatusReasons[detail?.inventoryStatusReason] ?? detail?.inventoryStatusReason}`
            : AppTranslations.genericWords.other
    }`);
};

// export const formatHeaderName = (name: string) => {
//     return capitalizeFirstLetter(name).replace(/_/g, " ");
// }

export const getTableHeadersName = (
    data: CensusEnums,
    status: CensusEquipmentStatusesEnum,
    statusDetail?: CensusEquipmentStatusDetailsEnum,
) => {
    return (
        `${data?.censusEquipmentStatuses?.[status]}${data?.censusEquipmentStatusDetails?.[statusDetail] ? `: ${data.censusEquipmentStatusDetails[statusDetail].toLowerCase()}` : ""}`);
};

export const filterOpenedSections =
    (data: CensusEnums, openedSections: Section[]) =>
        (summary: MappedSummary) => {
            if (openedSections.length === 0) {
                return true;
            }
            const containsMainHeader = openedSections
                .map((section) => section.name)
                .includes(
                    getTableHeadersName(
                        data,
                        summary?.inventoryStatus,
                        summary?.inventoryStatusDetail,
                    ),
                );

            if (openedSections.length === 1) {
                return containsMainHeader;
            }

            const containsReasonHeader = summary?.withReason?.some((reason) => {
                return openedSections
                    .map((section) => section.name)
                    .includes(getHeaderDetailsHeader(reason, data));
            });

            return containsMainHeader && containsReasonHeader;
        };

export const filterReasons =
    (data: CensusEnums, openedSections: Section[]) => (reasons) => {
        if (openedSections.length <= 1) {
            return true;
        }
        return openedSections
            .map((section) => section.name)
            .includes(getHeaderDetailsHeader(reasons, data));
    };

export const toggleSection = (section: Section, openedSections: Section[]) => {
    const openedSectionIndex = openedSections.findIndex(
        (s) => s.name === section.name && s.level === section.level,
    );
    if (
        openedSectionIndex > -1 &&
        openedSections[openedSectionIndex].level === 0
    ) {
        return [];
    } else if (openedSectionIndex > -1) {
        return openedSections.filter((s) => s.name !== section.name);
    } else {
        return [...openedSections, section];
    }
};
